<template>
  <div class="wrapper">
    <HeaderNav title="下载应用" v-if="!isMobile"></HeaderNav>
    <template v-if="!isInNative">
      <div class="section section-ios">
        <a href="https://apps.apple.com/app/id1644578076" class="link-a">
          <img src="../assets/images/ios.png" class="icon" />
          <div class="name">iOS下载</div>
        </a>
      </div>
      <div class="section">
        <a href="https://qidian-images.oss-cn-hangzhou.aliyuncs.com/app-release.apk" class="link-a">
          <img src="../assets/images/android.png" class="icon" />
          <div class="name">Android下载</div>
        </a>
      </div>
      <p class="tips">iOS下载链接微信浏览器无法打开，请复制页面链接到其它浏览器打开。</p>
    </template>
    <div class="section section-ios" v-if="isInNative&&isIOS">
      <div class="link-a" @click="toJump('https://apps.apple.com/app/id1644578076')">
        <img src="../assets/images/ios.png" class="icon" />
        <div class="name">iOS下载</div>
      </div>
    </div>
    <div class="section" v-if="isInNative&&isAndroid">
      <div class="link-a" @click="toJump('https://qidian-images.oss-cn-hangzhou.aliyuncs.com/app-release.apk')">
        <img src="../assets/images/android.png" class="icon" />
        <div class="name">Android下载</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPropertyList, getConstantCategory, getTypesList, } from '@/api/baseinfo';
import { Bridge } from '@/utils/bridge';
import { AppUtils } from '@/utils/bridge';

export default {
  name: 'industry-info',
  data() {
    return {
      isMobile: false,
      isAndroid: false,
      isIOS: false,
      isInNative: Bridge.isInNative(),
    }
  },
  created() {
    this.isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
    this.isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);//这是必须要写的，用来创建一些设置
    
    this.mobileTerminal((data) => {
      this.isMobile = data
    })

  },
  methods: {
    toJump(url) {
      /// 优先判断是否在原生环境中
      if (Bridge.isInNative()) {
          AppUtils.openWebUrl(url)
      }
    }
  },
}

</script>

<style lang="scss" scoped>
.wrapper{
  h3{
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    color: #222;
    text-align: center;
    margin-bottom: 120px;
  }
}
.section{
  width: 90%;
  max-width: 300px;
  height: 120px;
  background: #FFFFFF;
  border-radius: 10px;
  border: 1px solid #D8E0F0;
  margin: 20px auto 0;
  &-ios{
    margin-top: 100px;
  }
  .link-a{
    width: 300px;
    height: 120px;
    display: block;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon{
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  .name{
    font-size: 16px;
    color: #222;
    font-weight: bold;
    text-align: center;
  }
}
.tips{
  width: 90%;
  max-width: 300px;
  margin: 20px auto;
  line-height: 18px;
  font-size: 12px;
  color: #999;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/download-page.vue